import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import api, { errMsg } from "../lib/api";
import { toast, NoticeRegion } from "../lib/notices";
import { Mail, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      // Backend always returns 200 to avoid leaking whether the email exists.
      setSent(true);
      toast.success("If that email is registered, a sign-in link is on its way.");
    } catch (err) {
      toast.error(errMsg(err, "Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main id="main" tabIndex={-1} className="max-w-md mx-auto px-6 py-16">
        <div className="marquee-tag mb-4">// PASSWORD RESET</div>
        <h1 className="font-display font-black type-title mb-2 tracking-tighter">FORGOT PASSWORD?</h1>
        <p className="text-ink-muted mb-8">Enter the email associated with your DemoCraft account and we’ll send you a one-time magic sign-in link.</p>

        {sent ? (
          <div className="brutal-card" data-testid="forgot-sent">
            <div className="marquee-tag mb-3">// CHECK YOUR INBOX</div>
            <Mail size={40} className="mb-4" />
            <h2 className="font-display font-black type-heading tracking-tighter mb-2">Sign-in link sent.</h2>
            <p className="text-ink-muted">If <span className="font-mono-ui">{email}</span> matches a DemoCraft account, you’ll receive an email in the next few seconds. The link expires in 30 minutes.</p>
            <Link to="/login" className="brutal-btn brutal-btn-secondary mt-6 inline-flex">Back to sign in</Link>
          </div>
        ) : (
          <>
          <NoticeRegion />
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <label className="brutal-label" htmlFor="email">Email</label>
              <input id="email"
                data-testid="forgot-email"
                type="email"
                required
                className="brutal-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="brutal-btn w-full justify-center">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />} Send magic link
            </button>
            <p className="text-center text-sm mt-6">
              Remembered it? <Link to="/login" className="underline font-bold">Sign in</Link>
            </p>
          </form>
          </>
        )}
      </main>
    </div>
  );
}
